import { render, staticRenderFns } from "./MarkUpDescription.vue?vue&type=template&id=4b82be06&lang=html&"
import script from "./MarkUpDescription.vue?vue&type=script&lang=js&"
export * from "./MarkUpDescription.vue?vue&type=script&lang=js&"
import style0 from "./MarkUpDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports